import React from "react";
import { Switch, Route, Redirect } from "react-router-dom";
import LoginContainer from "../../containers/LoginContainer";
import SignupContainer from "../../containers/SignupContainer";
import AnonymousContainer from "../../containers/AnonymousContainer";
import ForgotPasswordContainer from "../../containers/ForgotPasswordContainer";
import HeaderBar from "../header/HeaderBar";
import { withStyles } from "@material-ui/core/styles";
import PropTypes from "prop-types";
import TournamentContainer from "../../containers/TournamentContainer";
import PSDLoginContainer from "../../containers/PSDLoginContainer";
import SportaLoginContainer from "../../containers/SportaLoginContainer";

const styles = (theme) => ({
  body: {
    marginTop: 0,
    // [theme.breakpoints.down("xs")]: {
    //   marginTop: 26
    // }
  },
});

const PublicRoutes = (props) => (
  <div>
    <HeaderBar user={props.user} />
    <div className={props.classes.body}>
      <Switch>
        <Route path="/" exact component={LoginContainer} />
        <Route
          path="/login/:psdCode"
          exact
          render={(path) => (
            <LoginContainer psdCode={path.match.params.psdCode} />
          )}
        />
        <Route
          path="/login/new/:psdCode"
          exact
          render={(path) => (
            <LoginContainer psdCode={path.match.params.psdCode} />
          )}
        />
        <Route path="/forgotpassword" component={ForgotPasswordContainer} />
        <Route path="/signup" component={SignupContainer} />
        <Route
          path="/new"
          render={() => (
            <AnonymousContainer user={props.user} userData={props.userData} />
          )}
        />
        <Route
          path="/tournament/:tournamentId"
          render={(path) => (
            <TournamentContainer
              tournamentId={path.match.params.tournamentId}
              user={props.user}
              admins={[]}
              setAuthListener={props.setAuthListener}
            />
          )}
        />
        <Route
          path="/psd/:code/:tournamentId"
          render={(path) => (
            <PSDLoginContainer
              code={path.match.params.code}
              tournamentId={path.match.params.tournamentId}
            />
          )}
        />
        <Route
          path="/prosoccerdata/:psdCode"
          render={(path) => (
            <AnonymousContainer
              user={props.user}
              psdCode={path.match.params.psdCode}
            />
          )}
        />
        <Route
          path="/i-reservations/:iResCode"
          render={(path) => (
            <AnonymousContainer
              user={props.user}
              iResCode={path.match.params.iResCode}
            />
          )}
        />
        <Route
          path="/sporta/:code"
          render={(path) => (
            <SportaLoginContainer code={path.match.params.code} />
          )}
        />
        <Route path="*" render={() => <Redirect to="/" />} />
      </Switch>
    </div>
  </div>
);

PublicRoutes.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(PublicRoutes);
